import { v4 as uuid } from "uuid";
import { OrganisationLineItem } from "./organisation";
import {
  SocialCommitmentLineItem,
  createDefaultCommitments,
} from "./commitment";
import { ProfileLineItem } from "./profile";
import { PlaceLatLng } from "./location";
import * as EntityProject from "../entities/project";

export type Project = EntityProject.Project;

export type ProjectLineItem = {
  id: string;
  organisationId: string;
  organisationName: string;
  organisationLogo: string;
  representativeEmail: string;
  representativeName: string;
  projectName: string;
  phoneNumber: string;
  faxNumber: string;
  projectAddressLine1: string;
  projectAddressLine2: string;
  projectCountry: string;
  projectState: string;
  projectCity: string;
  projectPostCode: string;
  geoLocation: PlaceLatLng;
  reportingDueDate: number;
  siteAddressSameAsProject: boolean;
  siteAddressLine1: string;
  siteAddressLine2: string;
  siteCountry: string;
  siteState: string;
  siteCity: string;
  sitePostCode: string;
  sitePhoneNumber: string;
  projectOwner: string;

  totalProjectValue: number;
  projectMargin: number;
  specialisedEquipmentValue: number;
  requiredSpend: number;

  deemedLabourRatio: number;
  deemedLabourHourlyRate: number;
  requiredHours: number;

  startDate: Date;
  endDate: Date;
  firstPackageStartDate?: Date;
  lastPackageEndDate?: Date;
  estimatedProgress: number;
  commitments: SocialCommitmentLineItem[];
  created: Date;
  archived: boolean;
};

export const createDefaultProject = (
  userProfile?: ProfileLineItem,
  organisation?: OrganisationLineItem
): ProjectLineItem => {
  return {
    id: uuid(),
    organisationId: organisation?.id || "",
    organisationName: organisation?.organisationName || "",
    organisationLogo: organisation?.organisationLogo || "",
    representativeName: organisation?.representativeName || "",
    representativeEmail: organisation?.representativeEmail || "",
    projectName: "",
    phoneNumber: "",
    faxNumber: "",
    projectAddressLine1: "",
    projectAddressLine2: "",
    projectCountry: "AU",
    projectState: "",
    projectCity: "",
    projectPostCode: "",
    geoLocation: { lat: 0, lng: 0 },
    reportingDueDate: 1,
    siteAddressSameAsProject: true,
    siteAddressLine1: "",
    siteAddressLine2: "",
    siteCountry: "AU",
    siteState: "",
    siteCity: "",
    sitePostCode: "",
    sitePhoneNumber: "",
    projectOwner: userProfile ? userProfile.id : "",
    totalProjectValue: 0,
    projectMargin: 0,
    specialisedEquipmentValue: 0,
    deemedLabourRatio: 0,
    deemedLabourHourlyRate: 0,
    requiredHours: 0,
    requiredSpend: 0,
    estimatedProgress: 0,
    commitments: createDefaultCommitments(),
    startDate: new Date(),
    endDate: new Date(),
    created: new Date(),
    archived: false,
  };
};
